import {Breakpoint, Dialog, DialogActions, DialogContent, IconButton, useTheme,} from '@mui/material';
import {CloseIcon} from '../../controls/MaterialUIIcons';
import {ButtonTypography, GreyOutlinedButton, PrimaryContainedButton} from '../Buttons/buttons';
import {EditDialogTitle, EditorModus, PaperComponent} from '../EditDialog/EditDialog';
import {useCallback, useMemo, useState} from 'react';
import {useResizeStyles} from '../EditDialog/stylesDialog';
import {ResizableBox} from 'react-resizable';


export interface ConfirmDialogProps {
  title: string;
  children: any;
  open: boolean;
  testId?: string;
  onClose: () => void;
  onConfirm: () => void;
  onAbort?: () => void;
  hideOnCloseIcon?: boolean;
  abortBtnTitle?: string;
  confirmBtnTitle?: string;
  dialogClassName?: string;
  width?: number;
  height?: number;
  maxHeight?: false | Breakpoint | undefined;
  maxWidth?: false | Breakpoint | undefined;
}

export type ConfirmActionState = {
  mode: EditorModus;
  onConfirm(): Promise<void> | void | undefined;
  onClose(): void | undefined;
  confirmBtnTitle?: string;
  abortBtnTitle?: string;
  message: string;
  title: string;
  open: boolean;

}


export const ConfirmDialog = (props: ConfirmDialogProps) => {
  const {
    title,
    children,
    open,
    onAbort,
    onClose,
    onConfirm,
    testId = '',
    maxWidth,
    hideOnCloseIcon = true,
    abortBtnTitle,
    confirmBtnTitle,
    dialogClassName,
  } = props;
  const {breakpoints} = useTheme();

  const defaultWidth = useMemo(() => {
    if (maxWidth) {
      return breakpoints.values[maxWidth];
    }
    return 600;
  }, [breakpoints.values, maxWidth]);


  const {height = 0, width = defaultWidth} = props;
  const {resizable} = useResizeStyles();
  const [resizeState, setResizeState] = useState({height: height, width: width});

  const measuredRef = useCallback((node: HTMLDivElement) => {
    if (node !== null && height === 0) {
      setResizeState(prev => {
        return {
          height: node.scrollHeight + 129,
          width: prev.width
        };
      });
    }
  }, [height]);
  return (
    <Dialog
      open={open}
      PaperComponent={PaperComponent}
      className={dialogClassName}
      onClose={() => onClose()}
      aria-labelledby='draggable-dialog-title'
    >
      <ResizableBox
        {...resizeState}
        className={resizable}
      >
        <>
          <EditDialogTitle
            style={{
              fontSize: '16px',
              display: 'Flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
            id='draggable-dialog-title'
            sx={hideOnCloseIcon ? {pt: 1.4, pb: 1.4} : {pt: .4, pb: .4}}
          >
            {title}
            {!!onClose && !hideOnCloseIcon ? (
              <IconButton
                aria-label='close'
                onClick={onClose}
                size='medium'
                sx={{
                  width: 40,
                  height: 40,
                }}
              >
                <CloseIcon
                  style={{color: 'white', alignSelf: 'flex-end'}}
                ></CloseIcon>
              </IconButton>
            ) : null}

          </EditDialogTitle>

          <DialogContent
            style={{
              padding: '15px',
              paddingLeft: '24px',
              display: 'flex',
            }}
            ref={measuredRef}
          >
            {children}
          </DialogContent>

          <DialogActions>
            <GreyOutlinedButton
              test-id={testId + '-nei-btn'}
              onClick={() => {
                onClose();
                onAbort?.();
              }}
              color='secondary'
            >
              <ButtonTypography>
                {abortBtnTitle ? abortBtnTitle : 'Nei'}
              </ButtonTypography>
            </GreyOutlinedButton>
            <PrimaryContainedButton
              test-id={testId + '-ja-btn'}
              onClick={() => {
                onClose();
                onConfirm();
              }}
            >
              <ButtonTypography>
                {confirmBtnTitle ? confirmBtnTitle : 'Ja'}
              </ButtonTypography>
            </PrimaryContainedButton>
          </DialogActions></>
      </ResizableBox>
    </Dialog>
  );
};
